import React from "react";
import "../../styles/ToolBar.css";
import "../../styles/Converter.css";

const Toolbar = (props) => {
  const handleDragEnter = (event) => {
    event.target.className = "KUIButton dragingovercommand";
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDragLeave = (event) => {
    event.target.className = "KUIButton";
  };
  let visible = props.enableCRUD ? "visible" : "hidden";
  let DimensionIntoTile = props.InTile;
  let buttonTileText;
  let classButton;

  if (DimensionIntoTile === true) {
    classButton = "buttonTile";
    buttonTileText = props.TextAddButtonTile;
  } else classButton = "buttonTool";

  return (
    <div id="Toolbar" style={{ textAlign: "center", visibility: visible, display: "flex" }}>
      {props.commands.map((item) => (
        <div id={`div${item.label}`} key={`div${item.label}`}>
          <button
            // style={{ height: "200px", width: "200px" }}
            //className="KUIButton"
            //className={`form-KUIButton ${DimensionIntoTile === "true" ? "buttonTile" : "buttonTool"}`}
            className={`${classButton}`}
            id={item.label}
            key={item.label}
            onClick={() => item.command()}
            onDrop={() => item.command()}
            onDragEnter={handleDragEnter}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
          ></button>
          {buttonTileText}
        </div>
      ))}
    </div>
  );
};

export default Toolbar;
